/* Midnight translation bridge reader (layout/theme.liquid #mw-strings).
   Falls back to the English argument if the bridge is unavailable. Defined
   defensively because several theme scripts share it. */
window.mwString = window.mwString || function (key, fallback) {
  return window.mwT ? window.mwT(key, fallback) : fallback;
};

/* Bag drawer · accessory suggestion.
   Adds the chosen accessory through the Ajax Cart API and re-renders the open drawer in place from the
   same response (the path product-form.js uses), so the page never navigates. One delegated listener,
   because the drawer markup is replaced on every cart update. */
(() => {
  if (window.mwBagUpsellBound) return;
  window.mwBagUpsellBound = true;

  const FALLBACK_ERROR = mwString('cart.upsell_add_failed', 'This could not be added to your bag. Please try again.');

  function setBusy(module, button, busy) {
    module.querySelectorAll('[data-mw-bag-upsell-add]').forEach((el) => {
      el.disabled = busy;
    });
    const label = button.querySelector('span');
    if (busy) {
      button.setAttribute('aria-busy', 'true');
      if (label) {
        button.dataset.idleLabel = label.textContent;
        label.textContent = 'Adding';
      }
    } else {
      button.removeAttribute('aria-busy');
      if (label && button.dataset.idleLabel) label.textContent = button.dataset.idleLabel;
    }
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-mw-bag-upsell-add]');
    if (!button || button.disabled) return;
    const module = button.closest('[data-mw-bag-upsell]');
    if (!module) return;
    event.preventDefault();

    const drawer = document.querySelector('cart-drawer');
    const error = module.querySelector('[data-mw-bag-upsell-error]');
    const title = button.dataset.productTitle || '';
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }
    setBusy(module, button, true);

    const sections = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map((section) => section.id)
      : [];
    const addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

    try {
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
          sections,
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();
      if (!response.ok || state.status) {
        throw new Error(state.description || state.message || FALLBACK_ERROR);
      }

      if (drawer && state.sections && state.sections['cart-drawer']) {
        drawer.renderContents(state);
        // renderContents re-opens the drawer on the next tick; the button is gone by then,
        // so focus returns to the panel and the change is announced.
        setTimeout(() => {
          const panel = drawer.querySelector('.drawer__inner');
          if (panel) panel.focus({ preventScroll: true });
          const live = document.getElementById('CartDrawer-LiveRegionText');
          if (live && title) live.textContent = mwString('cart.upsell_added', '[title] added to your bag.').replace('[title]', title);
        }, 60);
      }

      // The drawer is already rendered from this response, so the event is published as the drawer's own:
      // cart.js skips a second drawer fetch, while the product page and the /cart page still refresh.
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-items', cartData: state });
      }
    } catch (e) {
      console.error(e);
      setBusy(module, button, false);
      if (error) {
        error.textContent = e && e.message ? e.message : FALLBACK_ERROR;
        error.hidden = false;
      }
    }
  });
})();
